import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_PETITIONS_IN_FOOTER_WELL = defineFcm('promoted_petitions_in_footer_well')
	.asBoolean()
	.withDefault(false)
	.toConfig();
